__turbopack_context__.v({
  "bannerBackground": "validatedBanner-module-scss-module__mAi3QW__bannerBackground",
  "bannerContent": "validatedBanner-module-scss-module__mAi3QW__bannerContent",
  "bannerWrapper": "validatedBanner-module-scss-module__mAi3QW__bannerWrapper",
  "description": "validatedBanner-module-scss-module__mAi3QW__description",
  "divider": "validatedBanner-module-scss-module__mAi3QW__divider",
  "logoWrapper": "validatedBanner-module-scss-module__mAi3QW__logoWrapper",
});
